import CertificateFormPage from "./components/certificate/CertificateForm";

export const Certificate = () => {
  return (
    <>
      <CertificateFormPage />
    </>
  );
};
